export default {
  'billing.checkout.status.loading': 'Checking payment status...',
  'billing.checkout.status.confirming': 'We are confirming your payment...',
  'billing.checkout.status.cancelPending': 'Payment not completed',
  'billing.checkout.status.cancelPendingTimeout':
    'You did not complete the payment. If a charge was processed, it will appear in your account.',
  'billing.checkout.status.completed': 'Payment confirmed',
  'billing.checkout.status.failed': 'We could not confirm the payment',
  'billing.checkout.status.cancelled': 'Payment cancelled',
  'billing.checkout.status.expired': 'The payment session expired',
  'billing.checkout.status.pendingTimeout':
    'We are still confirming your payment. You can come back later.',
  'billing.checkout.status.unknown': 'Payment status unavailable',
  'billing.checkout.status.missingSession': 'Payment session was not found.',

  'billing.checkout.pageSubtitle': 'Your payment transaction result',
  'billing.checkout.cardTitle': 'Payment status',
  'billing.checkout.error.generic':
    'We could not retrieve the payment status. You can retry or go back.',

  'billing.checkout.section.financial': 'Financial summary',
  'billing.checkout.section.payment': 'Payment',
  'billing.checkout.section.billing': 'Billing',
  'billing.checkout.section.business': 'Outcome',

  'billing.checkout.fields.subtotal': 'Subtotal',
  'billing.checkout.fields.tax': 'Tax',
  'billing.checkout.fields.taxCalculatedAtCheckout': 'Calculated at checkout',
  'billing.checkout.fields.total': 'Total',
  'billing.checkout.fields.currency': 'Currency',
  'billing.checkout.fields.provider': 'Provider',
  'billing.checkout.fields.paymentMethod': 'Payment method',
  'billing.checkout.fields.completedAt': 'Payment date',
  'billing.checkout.fields.reference': 'Reference',
  'billing.checkout.fields.failureReason': 'Failure reason',
  'billing.checkout.fields.billingName': 'Billing name',
  'billing.checkout.fields.customerEmail': 'Email',
  'billing.checkout.fields.billingTaxId': 'Tax ID',
  'billing.checkout.fields.billingCountry': 'Country',
  'billing.checkout.fields.concept': 'Concept',

  'billing.checkout.paymentMethod.endingIn': '{brand} ending in {last4}',

  'billing.checkout.purpose.aiCreditRecharge': 'Credits added: {amount}',

  'billing.checkout.provider.stripe': 'Stripe',
  'billing.checkout.provider.bank-transfer': 'Bank transfer',
  'billing.checkout.provider.manual': 'Manual',

  'billing.checkout.action.back': 'Back to AI Billing',
  'billing.checkout.action.retry': 'Retry payment',
};
